import { Navigate, Outlet } from "react-router-dom";

const PublicRoute = ({
  isAllowed,
  redirectPath = "/",
}) => {
  if (!isAllowed) {
    return (
      <Navigate
        to={redirectPath}
        replace
      />
    );
  }

  return <Outlet />;
};

export default PublicRoute;